import { BaseService } from "./base";

export interface CorrecaoResponse {
  id: string;
  pageIndex: number;
  nota?: number;
}

export interface CorrecaoDetailsResponse {
  id: string;
  pageIndex: number;
  imagemUri: string;
  slots: CorrecaoDetailsSlotResponse[];
}

export interface CorrecaoDetailsSlotResponse {
  coordenadas: [number, number, number, number];
  gabarito: string;
  leitura: string[];
}

class CorrecoesService extends BaseService {
  constructor() {
    super("correcoes");
  }

  getById(id: string): Promise<CorrecaoResponse> {
    return this.get(id);
  }

  getDetails(id: string): Promise<CorrecaoDetailsResponse> {
    return this.get(`${id}/details`);
  }

  deleteById(id: string): Promise<void> {
    return this.delete(id);
  }
}

export default new CorrecoesService();
